import type { Classroom as ApiClassroom } from '@innovamat/glow-api-client';

import type { Classroom } from '../../modules/classroom';

function classroomMapper(classroom: ApiClassroom): Classroom {
  return {
    ...classroom,
  } as Classroom;
}

export { classroomMapper };
